import React, { Component } from 'react';
import TabPanelWage from './TabPanelWage'
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import styles from '../../styles/wage.module.css';
import { isAuthenticated } from '../../actions/authentication';
import { RenewToken } from '../../utils/token';
import { withCookies } from 'react-cookie';
import { ChatContext } from '@/ChatProvider';

class Wage extends Component {

    constructor(props) {
        super(props);

        this.state = { authenticated: false }
    }

    componentDidMount() {
        this.handleTitle();

        this.handleToken();
    }

    async handleToken() {
        await RenewToken(this.props);

        isAuthenticated().then((result) => {
            this.setState({ authenticated: result });
            this.context.setIsAuthenticated(result);
        });
    }

    handleTitle() {
        this.props.onLoadTitle(i18next.t('menu:wage'));
    }

    render() {
        return (
            this.state.authenticated &&  <div className={styles.rootWage}>
                <TabPanelWage />
            </div>
        );
    }
}

Wage.contextType = ChatContext;
export default withNamespaces(['menu'], { wait: true })(withCookies(Wage));